const ReferralEnglish = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <img
        style={{ width: "100%", objectFit: "contain" }}
        src="https://chargeerp-software.s3.ap-south-1.amazonaws.com/dev/dev/referral_eng.jpg"
      />
    </div>
  );
};


export default ReferralEnglish;
